import { CatButton } from '@blocks-react/components/Button';
import { FlyOutProps } from './types';
import cx from 'classnames';
import styles from './SelectDealerFlyout.module.scss';
import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconClose } from '@blocks-react/components/Icons/Close';
import { SELECT_DEALER_FLYOUT_IMG } from '../constants';

export const SelectDealerFlyout: FC<FlyOutProps> = (props) => {
  const { onClose, onSelectDealer, description, selectLabel, laterLabel } =
    props;
  return (
    <div className={cx('p-4', styles['flyout-wrapper'])}>
      <div className="d-flex justify-content-between">
        <CatHeading variant="body-sm" className="mr-5 pe-2">
          <span className={cx(styles['flyout-title'])}>{description}</span>
        </CatHeading>
        <CatIconClose onClick={onClose} />
      </div>
      <figure className="my-3">
        <img
          className="w-100"
          src={SELECT_DEALER_FLYOUT_IMG.src}
          alt={SELECT_DEALER_FLYOUT_IMG.alt}
        />
      </figure>
      <div className="d-flex ">
        <CatButton variant="primary" fullWidth onClick={onSelectDealer}>
          {selectLabel}
        </CatButton>
        <CatButton variant="ghost" fullWidth onClick={onClose}>
          {laterLabel}
        </CatButton>
      </div>
    </div>
  );
};
